module.exports = __webpack_public_path__ + "static/media/simControl.7fadf033.png";